import React from 'react'
import Menu from '../components/menu'
import Footer from '../components/footer'

export default function Contact() {
  return (
    <main className='MainPage'>
      <Menu active={5}/>
          <section className="Contact">
            <div className="content">
                <h1>Kontakt</h1>
                <p className='shortText'>Skontaktuj się z nami, aby omówić swój projekt konstrukcji stalowej. Jesteśmy gotowi odpowiedzieć na wszystkie Twoje pytania i przygotować indywidualną ofertę.</p>
                <div className="container">
                    <div className="row">
                        <div className="col-xl-6">
                            <div className="content">
                                <h2>Dane Kontaktowe</h2>
                                <div className="row">
                                    <div className="col-6">
                                        <h4><i class="fas fa-map-marker-alt"></i>Adres</h4>
                                        <p>Sadowiec Wrzosy 46c 98-355 Działoszyn</p>
                                    </div>
                                    <div className="col-6">
                                        <h4><i class="fas fa-phone-alt"></i>Telefon</h4>
                                        <p>+48 515 238 870</p>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-6">
                                        <h4><i class="fas fa-envelope"></i>Email</h4>
                                        <p>megamont@op.pl</p>
                                    </div>
                                </div>
                                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3126.3547115823967!2d18.889214776981333!3d51.13259303801453!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47109fbb71ee9869%3A0x5c12242db78e55f9!2sMegamont%20Mariusz%20Cymbik!5e1!3m2!1spl!2spl!4v1751991311249!5m2!1spl!2spl" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                            </div>
                        </div>
                        <div className="col-xl-6">
                            <div className="content">
                                <h2>Wyślij wiadomość</h2>
                               <form class="row g-3">
                                    <div class="col-md-6">
                                        <label for="Temat" class="form-label">Temat</label>
                                        <input type="text" class="form-control" id="Temat"/>
                                    </div>
                                    <div class="col-md-6">
                                        <label for="Company" class="form-label">Firma</label>
                                        <input type="text" class="form-control" id="Company"/>
                                    </div>
                                    <div class="col-md-6">
                                        <label for="Name" class="form-label">Imię</label>
                                        <input type="text" class="form-control" id="Name" placeholder="Imię"/>
                                    </div>
                                    <div class="col-md-6">
                                        <label for="Sname" class="form-label">Nazwisko</label>
                                        <input type="text" class="form-control" id="Sname" placeholder="Nazwisko"/>
                                    </div>
                                    <div class="col-md-6">
                                        <label for="email" class="form-label">Email</label>
                                        <input type="email" class="form-control" id="email"/>
                                    </div>
                                    <div class="col-md-6">
                                        <label for="Phone" class="form-label">Numer telefonu</label>
                                        <input type="number" class="form-control" id="Phone"/>
                                    </div>
                                    <div class="col-12">
                                        <label for="Text" class="form-label">Wiadomość</label>
                                        <textarea class="form-control" id="Text" cols="30" rows="10"></textarea>
                                    </div>
                                    <div class="col-12">
                                        <div class="form-check">
                                        <input class="form-check-input" type="checkbox" id="gridCheck"/>
                                        <label class="form-check-label" for="gridCheck">
                                            Wyrażam zgodę na przetwarzanie podanych przeze mnie informacji, by upoważniona osoba przygotowała i przekazała mi odpowiedź na moje zapytanie na podane przeze mnie kanały komunikacji (e-mail, telefon).
                                        </label>
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <button type="submit" class="btn btn-primary">Wyślij</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <Footer/>
    </main>
  )
}
